<template>
  <div class="layout-use-of-bar-four-content">
    <div class="descriptiom-layout-use-of-bar-four-wrapper">
      <div class="icon-wrapper">
        <IconCancel />
        <p class="layout-use-of-bar-four-description">{{ layoutUseOfBarFourDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCancel />
        <p class="layout-use-of-bar-four-description">{{ layoutUseOfBarFourDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCancel />
        <p class="layout-use-of-bar-four-description">{{ layoutUseOfBarFourDescription3 }}</p>
      </div>
    </div>
    <div
      class="layout-use-of-bar-four-card-item"
      :style="{ backgroundImage: `url(${layoutUseOfBarFourImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCancel } })
export default class LayoutsUseOfBarFourSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutUseOfBarFourDescription1(): string {
    return this.getElementText(11, 0)
  }

  get layoutUseOfBarFourDescription2(): string {
    return this.getElementText(11, 1)
  }

  get layoutUseOfBarFourDescription3(): string {
    return this.getElementText(11, 2)
  }

  get layoutUseOfBarFourImageSrc(): string {
    return this.getElementMedia(11, 3)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-use-of-bar-four-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-layout-use-of-bar-four-wrapper {
  display: flex;
  align-items: center;
  padding: 3rem;
}

.layout-use-of-bar-four-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.layout-use-of-bar-four-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.descriptiom-layout-use-of-bar-four-wrapper {
  padding: 2rem 0rem 1rem 0rem;
  position: relative;  

  display: grid;
  grid-template-columns: 51% 49%;  
}

.layout-use-of-bar-four-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;
}

.layout-use-of-bar-four-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
